// CHATGPT優化版

"use strict";
function _classCallCheck(a, b) {
    if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

// ===== HiDPI（Retina）支援 =====
var DPR = window.devicePixelRatio || 1;
function setupHiDPI(canvas, ctx, w, h) {
    canvas.style.width = w + "px";
    canvas.style.height = h + "px";
    canvas.width  = Math.round(w * DPR);
    canvas.height = Math.round(h * DPR);
    if (ctx && typeof ctx.setTransform === "function") {
        ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    } else if (ctx && typeof ctx.scale === "function") {
        if (typeof ctx.resetTransform === "function") ctx.resetTransform();
        ctx.scale(DPR, DPR);
    }
}

export var LegendStyle = function a(b) {
    var c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function(a) { return a };
    _classCallCheck(this, a),
    this.title = {
        content: b,
        fontSize: 14,
        fontFamily: "Arial",
        color: "#ffffff",
        margin: 5,
        border: 0,
        padding: 0,
        borderColor: "#ffffff",
        width: 0
    },
    this.item = {
        width: 30,
        height: 16
    },
    this.items = {
        border: 2,
        borderColor: "#ffffff",
        margin: 5
    },
    this.cursor = {
        width: 7,
        height: 3,
        marginLeft: 0,
        color: "#ffffff",
        type: "0" // "1" = outline, others = triangle
    },
    this.lVal = {
        fontSize: 12,
        fontFamily: "Arial",
        color: "#ffffff",
        width: 0,
        align: "b", // b = bottom, else = middle
        textTransform: c
    },
    this.realVal = {
        fontSize: 15,
        fontFamily: "Arial",
        color: "#ffffff",
        margin: 3,
        border: 2,
        padding: 3,
        borderColor: "#ffffff",
        width: 0,
        textTransform: c
    },
    this.legend = {
        margin: 2,
        border: 1,
        padding: 2,
        borderColor: "#ffffff",
        backgroundColor: "#000000"
    },
    this.title.width   = 3 * this.title.fontSize    * .75,
    this.lVal.width    = 5 * this.lVal.fontSize,
    this.realVal.width = 5 * this.realVal.fontSize
};

var createLegend, removeLegend;

!function() {
    var mapByKey = {}, refCount = 0;

    createLegend = function(c, d, e, f, label_unit, g, h) {
        if (mapByKey[c]) return null;

        var i = e,                     // 左側每格標籤列表（levels）
            j = f.length,              // 右下實時值欄位數
            k = document.createElement("canvas"),
            l = k.getContext("2d");

        mapByKey[c] = k;
        refCount++;

        h.cursor.width > h.item.height && (h.cursor.width = h.item.height);
        h.realVal.padding < 1 && (h.realVal.padding = 1);

        var m = Object.assign({}, h.legend),
            n = Object.assign({}, h.title),
            o = Object.assign({}, h.cursor),
            p = Object.assign({}, h.item),
            q = Object.assign({}, h.items),
            r = Object.assign({}, h.lVal),
            s = Object.assign({}, h.realVal);

        m.shell = m.margin + m.border + m.padding;
        n.shell = n.margin + n.border + n.padding;
        q.shell = q.margin + q.border;
        s.shell = s.margin + s.border + s.padding;

        n.blockWidth  = n.width + 2 * n.shell;
        n.blockHeight = n.fontSize + 2 * n.shell;

        if ("1" === o.type) {
            o.blockWidth = 0;
            o.blockHeight = 0;
            o.marginLeft = 0;
            o.height = 0;
        } else {
            o.blockWidth  = o.height + o.marginLeft;
            o.blockHeight = o.width;
        }

        p.blockWidth  = p.width;
        p.blockHeight = p.height;

        q.blockWidth  = p.blockWidth + 2 * q.shell;
        q.blockHeight = p.blockHeight * i.length + 2 * q.shell;

        r.blockWidth = r.width;

        s.blockWidth  = s.width + 2 * s.shell;
        s.blockHeight = s.fontSize + 2 * s.shell;

        var t = o.blockWidth + q.blockWidth + r.blockWidth,
            u = (r.align === "b" && p.blockHeight / 2 > q.shell)
                ? (q.blockHeight - q.shell + p.blockHeight / 2)
                : q.blockHeight;

        m.width  = t;
        m.height = n.blockHeight + u + s.blockHeight;
        m.height += (j - 1) * s.blockHeight;

        m.blockWidth  = m.width  + 2 * m.shell;
        m.blockHeight = m.height + 2 * m.shell;

        // HiDPI: 設定主畫布
        setupHiDPI(k, l, m.blockWidth, m.blockHeight);

        m.borderX = m.margin + m.border / 2;
        m.borderY = m.margin + m.border / 2;
        m.borderW = m.blockWidth - 2 * m.margin - m.border;
        m.borderH = m.blockHeight - 2 * m.margin - m.border;

        n.borderX = m.blockWidth / 2 - n.blockWidth / 2 + n.margin + n.border / 2;
        n.borderY = m.shell + n.margin + n.border / 2;
        n.borderW = n.blockWidth - 2 * n.margin - n.border;
        n.borderH = n.blockHeight - 2 * n.margin - n.border;
        n.fontX   = m.blockWidth / 2;
        n.fontY   = m.shell + n.blockHeight / 2;

        o.left  = m.shell + o.marginLeft;
        o.right = o.left + o.height;

        q.borderX = o.right + q.margin + q.border / 2;
        q.borderY = m.shell + n.blockHeight + q.margin + q.border / 2;
        q.borderW = q.blockWidth - 2 * q.margin - q.border;
        q.borderH = q.blockHeight - 2 * q.margin - q.border;

        p.firstX = o.right + q.shell;
        p.firstY = m.shell + n.blockHeight + q.blockHeight - q.shell - p.blockHeight;

        o.firstTop = p.firstY + p.height / 2 - o.width / 2;

        r.firstFontX = m.shell + o.blockWidth + q.blockWidth;
        r.firstFontY = (r.align === "b")
            ? (p.firstY + p.blockHeight)
            : (p.firstY + p.blockHeight / 2);

        s.borderX = m.blockWidth / 2 - s.blockWidth / 2 + s.margin + s.border / 2;
        s.borderY = m.shell + n.blockHeight + u + s.margin + s.border / 2;
        s.borderW = s.blockWidth - 2 * s.margin - s.border;
        s.borderH = s.blockHeight - 2 * s.margin - s.border;
        s.fillRectX = s.borderX + s.border / 2;
        s.fillRectY = s.borderY + s.border / 2;
        s.fillRectW = s.borderW - s.border;
        s.fillRectH = s.borderH - s.border;
        s.fontX = m.blockWidth / 2;
        s.fontY = s.fillRectY + s.fillRectH / 2;

        // 遮罩狀態
        for (var v = new Array(i.length), w = 0; w < i.length; w++) v[w] = !1;

        var x = {
            onClick: function(ax, ay) {
                var cpx = ax - p.firstX;
                if (cpx >= 0 && cpx < p.width) {
                    var ey = ay - p.firstY,
                        row = -Math.floor(ey / p.height);
                    if (row >= 0 && row < i.length) {
                        v[row] = !v[row];
                        if (v[row]) {
                            l.fillStyle = m.backgroundColor;
                            l.clearRect(p.firstX, p.firstY - p.height * row, p.width, p.height);
                            l.fillRect (p.firstX, p.firstY - p.height * row, p.width, p.height);
                            z.fillStyle = m.backgroundColor;
                            z.clearRect(p.firstX, p.firstY - p.height * row, p.width, p.height);
                            z.fillRect (p.firstX, p.firstY - p.height * row, p.width, p.height);
                        } else {
                            l.fillStyle = d[row];
                            l.clearRect(p.firstX, p.firstY - p.height * row, p.width, p.height);
                            l.fillRect (p.firstX, p.firstY - p.height * row, p.width, p.height);
                            z.fillStyle = d[row];
                            z.clearRect(p.firstX, p.firstY - p.height * row, p.width, p.height);
                            z.fillRect (p.firstX, p.firstY - p.height * row, p.width, p.height);
                        }
                        g(row, v[row], v);
                    }
                }
            },
            onMouseLngLatChange: function(vals, idx) {
                // 使用同一個 context，避免未設 Transform 造成放大
                var c = l;
                c.font = s.fontSize + "px " + s.fontFamily;
                c.textAlign = "center";

                c.clearRect(0, 0, m.blockWidth, m.blockHeight);
                // 快照與主畫布幾何一致
                c.drawImage(y, 0, 0, m.blockWidth, m.blockHeight);

                var textX = s.fontX + 3 * s.fontSize / 4 / 2;
                c.fillStyle = s.color;

                // 安全取值：避免 undefined
                for (var eIdx = 0; eIdx < j; eIdx++) {
                    var unit = (Array.isArray(label_unit) && eIdx < label_unit.length && label_unit[eIdx]) ? label_unit[eIdx] : '';
                    var hasVal = (Array.isArray(vals) && eIdx < vals.length && vals[eIdx] !== null && vals[eIdx] !== undefined);
                    var vstr = hasVal ? (s.textTransform ? s.textTransform(vals[eIdx]) : String(vals[eIdx])) : "ND";
                    var txt  = unit && hasVal ? (vstr + " " + unit) : vstr;
                    c.fillText(txt, textX, s.fontY + eIdx * s.blockHeight, s.width);
                }

                if (idx !== -1) {
                    if ("1" === o.type) {
                        c.globalCompositeOperation = "difference";
                        c.strokeStyle = "#ffffff";
                        c.lineWidth = o.width;
                        c.beginPath();
                        c.rect(p.firstX + o.width / 2, p.firstY - idx * p.height + o.width / 2, p.width - o.width, p.height - o.width);
                        c.stroke();
                        c.globalCompositeOperation = "source-over";
                    } else {
                        var top = o.firstTop - idx * p.height;
                        c.fillStyle = o.color;
                        c.beginPath();
                        c.moveTo(o.left, top);
                        c.lineTo(o.left, top + o.width);
                        c.lineTo(o.right, top + o.width / 2);
                        c.lineTo(o.left, top);
                        c.fill();
                    }
                }
            }
        };

        // ===== 初始（靜態）繪製到 k =====
        (function() {
            var a2 = k.getContext("2d"),
                b2, c2, e2, g2;

            a2.textBaseline = "middle";
            a2.fillStyle = m.backgroundColor;
            a2.fillRect(m.borderX, m.borderY, m.borderW, m.borderH);

            if (m.border > 0) {
                a2.strokeStyle = m.borderColor;
                a2.lineWidth = m.border;
                a2.strokeRect(m.borderX, m.borderY, m.borderW, m.borderH);
            }

            a2.font = n.fontSize + "px " + n.fontFamily;
            a2.fillStyle = n.color;
            a2.textAlign = "center";
            a2.fillText(n.content, n.fontX, n.fontY);

            if (n.border > 0) {
                a2.strokeStyle = n.borderColor;
                a2.lineWidth = n.border;
                a2.strokeRect(n.borderX, n.borderY, n.borderW, n.borderH);
            }

            if (q.border > 0) {
                a2.strokeStyle = q.borderColor;
                a2.lineWidth = q.border;
                a2.strokeRect(q.borderX, q.borderY, q.borderW, q.borderH);
            }

            b2 = 0; c2 = p.firstX; e2 = p.firstY;
            for (; b2 < i.length; b2++) {
                a2.fillStyle = d[b2];
                a2.fillRect(c2, e2, p.width, p.height);
                e2 -= p.height;
            }

            a2.font = r.fontSize + "px " + r.fontFamily;
            a2.fillStyle = r.color;
            a2.textAlign = "start";
            b2 = 0; c2 = r.firstFontX; e2 = r.firstFontY;
            for (; b2 < i.length; b2++) {
                g2 = r.textTransform(i[b2]);
                a2.fillText(g2, c2, e2, r.width);
                e2 -= p.height;
            }

            a2.font = s.fontSize + "px " + s.fontFamily;
            a2.fillStyle = s.color;
            a2.textAlign = "start";
            a2.strokeStyle = s.borderColor;
            a2.lineWidth = s.border;

            var hx = s.borderX + 3 * s.fontSize / 4 / 2;
            for (b2 = 0; b2 < j; b2++) {
                if (s.border) a2.strokeRect(hx, s.borderY + b2 * s.blockHeight, s.borderW, s.borderH);
                a2.fillText(f[b2], m.shell, s.fontY + b2 * s.blockHeight, s.borderX - m.shell);
            }
        })();

        // ===== 快照畫布 y：與 k 完全同尺寸、同縮放，避免移位 =====
        var y = document.createElement("canvas"),
            z = y.getContext("2d");
        setupHiDPI(y, z, m.blockWidth, m.blockHeight);
        z.drawImage(k, 0, 0, m.blockWidth, m.blockHeight);

        // ===== 點擊事件：把 computeCnvRealXY 的實際像素換回 CSS 像素 =====
        k.onclick = function(ev) {
            var pt = (KXD && KXD.utility && KXD.utility.func && typeof KXD.utility.func.computeCnvRealXY === "function")
                ? KXD.utility.func.computeCnvRealXY(k, ev.offsetX, ev.offsetY)
                : null;
            var cx = pt && pt.pointX != null ? pt.pointX / DPR : ev.offsetX;
            var cy = pt && pt.pointY != null ? pt.pointY / DPR : ev.offsetY;
            x.onClick(cx, cy);
        };

        // ===== 外部更新資料 / hover 索引 =====
        k.dataChange = function(vals, idx) {
            x.onMouseLngLatChange(vals, (typeof idx === "number" ? idx : -1));
        };

        return k;
    };

    removeLegend = function(c) {
        var d = mapByKey[c];
        return !!d && (d.onclick = null, delete mapByKey[c], refCount--, !0);
    };
}();

export { createLegend, removeLegend };
